import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ProposalGalleryManager } from "@/components/admin/ProposalGalleryManager";
import { ProposalBeforeAfterManager } from "@/components/admin/ProposalBeforeAfterManager";

export default function ProposalGallery() {
  return (
    <div className="container mx-auto py-8 space-y-6">
      <div>
        <h1 className="text-3xl font-bold mb-2">Proposal Gallery</h1>
        <p className="text-muted-foreground">
          Manage images that appear in your proposals when customer-specific photos aren't available.
          These images are separate from your website gallery.
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Gallery Images</CardTitle>
          <CardDescription>
            Upload and organize images that will be displayed in customer proposals.
            The first 6 active images will be shown in proposals.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ProposalGalleryManager />
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Before/After Transformation Projects</CardTitle>
          <CardDescription>
            Upload before and after images to showcase your transformation work.
            Up to 2 projects will be shown with an interactive slider.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ProposalBeforeAfterManager />
        </CardContent>
      </Card>
    </div>
  );
}
